import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { Folder } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';

export interface MatterFoldersParams {
	matterId: string;
}

@Injectable({
	providedIn: 'root',
})
export class MatterFoldersService extends Repo<Folder, MatterFoldersParams> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;
	expandedFolders: string[];

	constructor(private firestore: AngularFirestore) {
		super(firestore);

		this.expandedFolders = [];
	}

	ToggleExpandedFolder(folderId: string): void {
		if (this.expandedFolders.includes(folderId)) {
			this.expandedFolders = this.expandedFolders.filter(
				(expandedId) => expandedId !== folderId,
			);
		} else {
			this.expandedFolders.push(folderId);
		}
		this.expandedFolders = this.expandedFolders.slice(-50); // arbitrary limit to the number of IDs being stored
	}

	GetCollectionPath(pathParam: MatterFoldersParams): string {
		return CollectionPaths.business_matter_folders(
			this.businessId,
			pathParam.matterId,
		);
	}
}
